import { useTrainingMode } from "./TrainingModeContext";
import s from "./training.module.css";

export default function TrainingFeedbackToast() {
  const { feedback } = useTrainingMode();
  if (!feedback?.message) return null;

  const isInfo = feedback.tone === "info";
  const cls = [
    s.trnRoot,
    s.trainingFeedback,
    isInfo ? s.trainingFeedbackInfo : "",
    feedback.tone === "done" ? s.trainingFeedbackDone : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={cls} role="status" aria-live="polite">
      <span className={s.trainingFeedbackIcon} aria-hidden>
        {isInfo ? "i" : "✓"}
      </span>
      <span>{feedback.message}</span>
    </div>
  );
}
